import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import { Box, Button, Card, Grid, TextField } from "@mui/material";
import { postSaveObjectApi, putUpdateObjectApi } from "api/general";
import { AGENDA_TEMPLATE } from "app/utils/constants/customConstant";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import moment from 'moment';

function AddUpdateAgendaTemplateCard({ afterUpdateFunc, selectedAgendaTemplate, onClose, addAfterTable }) {
    const empty_agendaTemplateObj = {
        title: '',
        body: '',
        pdate: moment().format('YYYY-MM-DD HH:mm:ss')
    }
    const [agendaTemplateObj, setAgendaTemplateObj] = useState(empty_agendaTemplateObj)
    const { authUser } = useSelector(state => state.auth);

    useEffect(() => {
        if (selectedAgendaTemplate) {
            setAgendaTemplateObj(selectedAgendaTemplate);
        } else {
            setAgendaTemplateObj(empty_agendaTemplateObj);
        }
    }, [selectedAgendaTemplate])

    const handleChange = name => (e) => {
        setAgendaTemplateObj({
            ...agendaTemplateObj,
            [name]: e.target.value
        })
    }

    const handleAddUpdateAgendaTemplateInfo = () => {
        onClose();

        const agendaTemplateData = {
            ...agendaTemplateObj,
            userId: authUser.id,
            pdate: moment().format('YYYY-MM-DD HH:mm:ss')
        };

        selectedAgendaTemplate ?
            Swal.fire({
                title: 'Gündem Şablonu Güncelleme İşlemi',
                text: "Güncellemek istediğinizden emin misiniz?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Evet Güncelle',
                cancelButtonText: "Vazgeç"
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const result = await putUpdateObjectApi(AGENDA_TEMPLATE, agendaTemplateData);

                    if (result.status) {
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: 'Güncelleme başarılı.',
                            showConfirmButton: false,
                            timer: 1500
                        });

                        afterUpdateFunc && afterUpdateFunc({ ...agendaTemplateData })
                    }
                }
            })
            :
            Swal.fire({
                title: 'Gündem Şablonu Ekleme İşlemi',
                text: "Eklemek istediğinizden emin misiniz?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Evet Ekle',
                cancelButtonText: "Vazgeç"
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const result = await postSaveObjectApi(AGENDA_TEMPLATE, agendaTemplateData);

                    if (result.status) {


                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: 'Ekleme başarılı.',
                            showConfirmButton: false,
                            timer: 1500
                        });

                        addAfterTable({ id: result.data.insertId, ...agendaTemplateData })
                    }
                }
            })
    };

    return (
        <>
            <JumboCardQuick>
                <Grid container marginY={1} spacing={1} rowSpacing={1}>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            label="Şablon Başlığı"
                            fullWidth
                            value={agendaTemplateObj['title']}
                            onChange={handleChange("title")}
                            required
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            label="Şablon İçeriği"
                            fullWidth
                            multiline
                            rows={8}
                            value={agendaTemplateObj['body']}
                            onChange={handleChange("body")}
                            required
                            placeholder="Gündem şablonu içeriğini buraya yazın..."
                        />
                    </Grid>
                </Grid>
            </JumboCardQuick>

            <br />
            <Card>
                <Box sx={{ margin: '8px' }}>
                    <Grid container justifyContent="flex-end" spacing={1}>
                        <Grid item>
                            <Button variant="contained" color="success" onClick={() => handleAddUpdateAgendaTemplateInfo()}>
                                {selectedAgendaTemplate ? "Güncelle" : "Kaydet"}
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="error" onClick={() => onClose()}>
                                Kapat
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Card>
        </>
    )
}

export default AddUpdateAgendaTemplateCard